import React from 'react';
import {
	Box,
	Typography,
	Avatar,
	useTheme,
	useMediaQuery,
} from '@mui/material';
import stylesLogo from '../Accounts/Account.styles';
import { capitalize } from '../../hepler/functions';
import { useTranslation } from '../../hooks/useTranslation';

const Accounts = (props) => {
	const { account, customDetails } = props;
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const isTablet = useMediaQuery(theme.breakpoints.down('md'));

	const fipId = account?.fipId;
	const lastFourDigits = account?.maskedAccNumber?.slice(-4);

	return (
		<Box
			sx={{
				fontFamily: customDetails?.fontFamily,
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				padding: isMobile ? '12px 12px' : '12px 12px',
				border: '1px solid #CCCCCC',
				borderRadius: '12px',
				marginBottom: '12px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					gap: isMobile ? '8px' : '12px',
					alignItems: 'center',
					minWidth: 0,
					flex: 1,
					overflow: 'hidden',
				}}
			>
				<Avatar
					alt={''}
					src={global.objectFormatFip?.[fipId]?.productIconUri}
					variant="square"
					sx={{
						width: '16px',
						height: '16px',
						objectFit: 'contain',
						flexShrink: 0,
						'& .MuiAvatar-img': {
							objectFit: 'contain',
						},
					}}
				/>

				<Typography
					sx={{
						fontSize: isMobile ? '0.75rem' : isTablet ? '0.75rem' : '0.875rem',
						fontFamily: customDetails?.fontFamily,
						color: '#000',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						minWidth: 0,
					}}
				>
					{t(`fips.${global.objectFormatFip?.[fipId]?.fipId}`)}
				</Typography>
			</Box>
			<Box
				sx={{
					display: 'flex',
					gap: isMobile ? '4px' : '8px',
					alignItems: 'center',
					flexShrink: 0,
				}}
			>
				<Typography
					sx={{
						fontSize: isMobile ? '0.75rem' : isTablet ? '0.75rem' : '0.875rem',
						fontFamily: customDetails?.fontFamily,
						color: '#666',
					}}
				>
					{capitalize(account?.accType)}
				</Typography>
				<Typography
					sx={{
						fontSize: isMobile ? '0.75rem' : isTablet ? '0.75rem' : '0.875rem',
						fontFamily: customDetails?.fontFamily,
						color: '#666',
					}}
				>
					•
				</Typography>
				<Typography
					sx={{
						fontSize: isMobile ? '0.75rem' : isTablet ? '0.75rem' : '0.875rem',
						fontFamily: customDetails?.fontFamily,
						color: '#666',
					}}
				>
					{lastFourDigits}
				</Typography>
			</Box>
		</Box>
	);
};

export default Accounts;
